const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");
module.exports = function getSiteMetaData() {
	return generalSettings.data.siteMetaData;
};
